import { render, staticRenderFns } from "./GameOfLife.vue?vue&type=template&id=49433c68&"
import script from "./GameOfLife.vue?vue&type=script&lang=js&"
export * from "./GameOfLife.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports